var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-box"},[_c('p',{staticClass:"line",class:{
      left:_vm.newPosition === 'left',
      center:_vm.newPosition === 'center',
      right:_vm.newPosition === 'right',
    }},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.$attrs.name))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0016b1f9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormComponents/components/line/index.vue
// module id = null
// module chunks = 